import { NamedModule as E } from "@im-js/token";
var o = new E("#PREFERENCE"),
  e = new E("#PREFERENCE_VARIABLE"),
  t = new E("#PREFERENCE_WORD");
export { o as PREFERENCE, e as PREFERENCE_VARIABLE, t as PREFERENCE_WORD };